import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

export class TaxaJurosMaximaAgente extends BaseEntity {
    public taxaJurosMaximaAgente: number;
    public dataInicioValidade: Date;
    public modoEdicao?: boolean;
    public taxaJurosMaximaAgenteOriginal: number;
    public dataInicioValidadeOriginal: Date;
}